import { artworkCmd } from './apiClient';

/** Where a thread is pinned (W5-AR2): on a layer and an offset from its top-left, or a point on a page. */
export interface CommentAnchor {
  readonly pageId: string;
  readonly nodeId?: string | null;
  readonly x: number;
  readonly y: number;
  /** The artboard it fell on, and where on it: what the view page shows it by. */
  readonly boardId?: string | null;
  readonly boardX?: number | null;
  readonly boardY?: number | null;
}

export interface CommentPerson {
  readonly id: string;
  readonly name: string | null;
  readonly avatarUrl: string | null;
}

export interface FileComment {
  readonly id: string;
  readonly body: string;
  readonly author: CommentPerson;
  readonly mentions: readonly string[];
  readonly createdAt: string;
  readonly mine: boolean;
}

export interface CommentThread extends FileComment {
  readonly anchor: CommentAnchor;
  readonly resolved: boolean;
  readonly resolvedAt: string | null;
  readonly replies: readonly FileComment[];
}

export const listComments = (documentId: string) => artworkCmd<{ threads: CommentThread[]; canComment: boolean }>('artwork.comments.list', { documentId });
export const createComment = (documentId: string, anchor: CommentAnchor, body: string, mentions: readonly string[]) =>
  artworkCmd<CommentThread>('artwork.comments.create', { documentId, anchor, body, mentions });
export const replyComment = (documentId: string, threadId: string, body: string, mentions: readonly string[]) =>
  artworkCmd<FileComment>('artwork.comments.reply', { documentId, threadId, body, mentions });
export const resolveComment = (documentId: string, threadId: string, resolved: boolean) => artworkCmd<{ id: string; resolved: boolean }>('artwork.comments.resolve', { documentId, threadId, resolved });
export const deleteComment = (documentId: string, commentId: string) => artworkCmd<{ id: string }>('artwork.comments.delete', { documentId, commentId });
